import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from '../services';
import { ConfigurationViewChargePage } from './configuration-view-charge/configuration-view-charge';


@Component({
  selector: 'page-configuration-payments-charges',
  templateUrl: 'configuration-payments-charges.html',
})
export class ConfigurationPaymentsChargesPage {



  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    private configurationServices: ConfigurationServices) {

    this.configurationServices.getListCharges(this.globals.restaurant_uid);
  }

  openCharge(charge) {
    this.navCtrl.push(ConfigurationViewChargePage, {
      charge: charge,
    })
  }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payments-charges/configuration-payments-charges.ts